angular.module('impactx.lot').controller('LotListCtrl',[
    'selectedListItems',
    'dataGen',
    '$route',
    'ToastService',
    'ConfirmationService',
    'BackFactory',
    LotListCtrl]);

function LotListCtrl(selectedListItems, dataGen, $route, ToastService, ConfirmationService, BackFactory)
{
    BackFactory.setLotId(0);

    var ctrl = this;

    this.getDetailLink = function() {
        return "lotdetail/" + selectedListItems.getFirstSelectedId();
    };

    this.getLotBuyerLink = function() {
        return "lotbuyerlist/" + selectedListItems.getFirstSelectedId();
    };

    this.getLotSupplierLink = function() {
        return "lotsupplierlist/" + selectedListItems.getFirstSelectedId();
    };

    this.getCSCLink = function() {
        return "cscontractlist/lot/" + selectedListItems.getFirstSelectedId();
    };

    this.getEditClosedCalendarLink = function() {
        return "closedcalendar/" + selectedListItems.getFirstSelectedId() + "/0";
    };

    this.canDelete = function() {
        if (!selectedListItems.isMultiSelection())
        {
            return false;
        }
        else
        {
            var items = selectedListItems.getSelectedItems();
            for (var i = 0; i < items.length; i++)
            {
                if (!items[i].canEdit.value)
                {
                    return false;
                }
            }
            return true;
        }
    };

    this.deleteDialog = function(event, trns) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, trns.confirmDelete,
            trns.delete, trns.abort);
    };

    this.delete = function() {
        var dataObj = {
            ids: selectedListItems.getSelectedIds()
        };
        var temp = {};
        dataGen.postAsForm(temp, dataObj, "/lot/deletemultiple").then(function() {
            $route.reload();
            ToastService.openStandardToast(temp.trns.deleteSuccess);
        });
    };

    this.buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'ViewLotDetail'},
        {label: "lotbuyer", linkFunction: ctrl.getLotBuyerLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'ListLotBuyer'},
        {label: "lotsupplier", linkFunction: ctrl.getLotSupplierLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'ListLotSupplier'},
        {label: "contracts", linkFunction: ctrl.getCSCLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'CSContract'},
        {label: "closedCalendar", linkFunction: ctrl.getEditClosedCalendarLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'EditClosedCalendar'},
        {label: "delete", action: ctrl.deleteDialog, condition: ctrl.canDelete, process: 'EditLot'}];

    this.meta = {
        rowTemplate: 'modules/lot/templates/lotlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/lot/list',
        id: "lotlist",
        mainAction : {id:"new", link: "#/lotdetail/0", icon:"mdi-plus"},
        excelParams: {
            params: [{param: 'TenderId', intValue: 0}]
        },
        buttonDefinition: ctrl.buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}